import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useSSA } from "../SSAContext";
import { Card, Empty, ReadinessBadge, StatusBadge } from "../ui";

export function RequestTable({ rows, linkBase, testid }) {
  if (!rows.length) return <Empty>No service requests yet — open a service from the catalogue or press “Next step” in the Demo Console.</Empty>;
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm" data-testid={testid}>
        <thead><tr className="text-left text-[10px] uppercase tracking-wider text-slate-400">
          <th className="py-2">Reference</th><th>Service</th><th>Country</th><th>Readiness</th><th>Status</th><th>Updated</th>
        </tr></thead>
        <tbody className="divide-y divide-slate-100">
          {rows.map((r) => (
            <tr key={r.id} className="hover:bg-slate-50">
              <td className="py-2.5"><Link to={`${linkBase}/${r.id}`} className="font-mono font-semibold text-[#0072CE] hover:underline" data-testid={`request-link-${r.id}`}>{r.id}</Link>
                {r.is_demo && <span className="ml-2 text-[9px] font-bold bg-amber-100 text-amber-800 rounded px-1">DEMO</span>}</td>
              <td><span className="font-mono text-xs text-slate-400">{r.service_id}</span> {r.service_name}</td>
              <td>{r.country}</td>
              <td><ReadinessBadge value={r.readiness} /></td>
              <td><StatusBadge status={r.status} /></td>
              <td className="text-xs text-slate-500">{new Date(r.updated_at).toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default function BuyerRequestsPage() {
  const { call, refreshKey } = useSSA();
  const [rows, setRows] = useState([]);
  useEffect(() => { call("get", "/requests?view=buyer").then((d) => setRows(d.requests)).catch(() => {}); }, [call, refreshKey]);
  return (
    <div data-testid="buyer-requests-page">
      <h1 className="font-display text-3xl font-semibold text-slate-900">My service requests</h1>
      <p className="text-sm text-slate-500 mt-1 mb-6">Status, quotation versions, clarifications, acceptance and PO tracking.</p>
      <Card><RequestTable rows={rows} linkBase="/services/requests" testid="buyer-requests-table" /></Card>
    </div>
  );
}
